import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-family: var(--font-display);
  font-size: clamp(1.85rem, 4vw, 2.35rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  margin: 1.75rem 0 0.35rem;
  color: var(--text-primary);
`;

const Updated = styled.p`
  margin: 0 0 2rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 0.65rem;
  color: var(--text-primary);
`;

const Prose = styled.div`
  color: var(--text-secondary);
  line-height: 1.65;
  font-size: 0.98rem;

  p {
    margin: 0 0 0.85rem;
  }

  ul {
    margin: 0 0 0.85rem;
    padding-left: 1.25rem;
  }

  li {
    margin-bottom: 0.45rem;
  }

  a {
    color: var(--primary-light);
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  strong {
    color: var(--text-primary);
    font-weight: 600;
  }
`;

const LegalPageLayout = ({ title, lastUpdated, children }) => (
  <Content>
    <Title>{title}</Title>
    {lastUpdated && <Updated>Last updated: {lastUpdated}</Updated>}
    <Prose>{children}</Prose>
  </Content>
);

export { Section, SectionTitle };
export default LegalPageLayout;
